/**
 * Enum representing the different platforms the game can run on.
 */
export enum Platforms {
    /** The game is running in the Wonderland Engine editor or standalone build. */
    WonderlandEngine = 0,
    /** The game is running on the CrazyGames platform. */
    CrazyGames,
}

/**
 * Checks if the game is currently running on the specified platform.
 * @param platform The platform to check against.
 * @returns True if the game is running on the specified platform, false otherwise.
 */
export function isOnPlatform(platform: Platforms): boolean {
    if (platform === Platforms.WonderlandEngine) {
        // Currently, this always returns true for Wonderland Engine.
        // This might need adjustment if specific detection logic is needed.
        return true;
    } else if (platform === Platforms.CrazyGames) {
        // Checks for the existence of the CrazyGames SDK object on the window.
        return !!(window as any).CrazyGames;
    }
    // Default case, should not happen with the current enum definition.
    return false;
}
